import { TableContainer, MenuItem, Typography } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { useStyles } from "./styles";
import "./override.css";
import { IRequestBody } from "../../Constants/interfaces";
import api_endpoints, { base_url } from "../../Api/end_points";
import { PostFileUpload, CreateFileListEntry } from "./UploadAndShareAPICalls";
import ButtonWithIcon, { CREATE_TYPE } from "../../Common/Buttons";
const environmentList = [
  {
    environmentName: "STAGE",
  },
  {
    environmentName: "PROD",
  },
];
const UploadAndShare = (props: any) => {
  const userName = useSelector((state: RootState) => {
    return {
      name: state.user.name,
    };
  });

  const classes = useStyles();
  const [showUploader, setShowUploader] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [bundleId, setBundleId] = useState("");
  const [appName, setAppName] = useState("");
  const [version, setVersion] = useState("");
  const [ipaUrl, setIpaUrl] = useState("");
  const [isAndroid, setIsAndroid] = useState(false);
  const [comments, setComments] = useState("");
  const [uploadedUrl, setUploadedUrl] = useState<any>("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [plistUrl, setPlistUrl] = useState("");
  const dropRef = useRef<HTMLDivElement>(null);

  const [selectedEnvironment, setSelectedEnvironment] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    resetState();
  }, []);

  const resetState = (showUploader = false) => {
    setIpaUrl("");
    setBundleId("");
    setAppName("");
    setVersion("");
    setSelectedFileName("");
    setUploadProgress(0);
    setShowUploader(showUploader);
  };
  const handleMainFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    processFile(file);
  };

  const processFile = (file: File) => {
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (ext !== "apk" && ext !== "ipa") {
      alert("Only .apk or .ipa files are allowed.");
      return;
    }
    const isAndroid = file.name.endsWith("apk");
    setIsAndroid(isAndroid);
    setSelectedFileName(file.name);
    handleUpload(file);
  };

  const handleUpload = async (file: File) => {
    setUploadProgress(1);
    // const isAndroid = file.name.endsWith("apk");
    // setIsAndroid(isAndroid);

    const apiData = {} as IRequestBody;
    apiData.domain = base_url;
    apiData.endPoint = api_endpoints.fileupload_S3bucket;
    apiData.showLoader = false;
    let formData: any = new FormData();
    const input = file.name;
    const parts = input.split(".");
    const last = parts.pop();
    const modified = parts.join("_") + "." + last;

    let data = {
      type: "GENERIC",
      fileNameWithExtension: modified,
    };

    formData.append("file", file);
    formData.append("data", JSON.stringify(data));
    apiData.payLoad = formData;

    const resp = await PostFileUpload(
      apiData,
      fileUploadSuccessCallback,
      fileUploadErrorCallback,
      fileUploadProgressCallBack
    );
    fileUploadSuccessCallback(resp);
  };

  const fileUploadProgressCallBack = (progressEvent: any) => {
    const percent = Math.round(
      (progressEvent.loaded * 100) / (progressEvent.total || 1)
    );
    setUploadProgress(percent);
  };

  const fileUploadSuccessCallback = (response: any) => {
    const data = response.data;
    if (data && data.imageUrl) {
      setUploadedUrl(data);
      const isFileAndroid = data.imageUrl.includes(".apk");
      if (isFileAndroid) {
        setUploadProgress(100);
        // generateUniquePage(data.imageUrl, null, isAndroid);
      } else {
        setUploadProgress(100);
        setIpaUrl(data.imageUrl);
      }
    } else {
      alert("Upload failed, no URL returned.");
    }
  };

  const fileUploadErrorCallback = (error: any) => {
    console.error("Upload error:", error);
    alert("Upload failed.");
    setUploadProgress(0);
  };

  const generateUniquePage = async (
    data: string,
    ipaUrls: string | null = null,
    isAndroid: boolean
  ) => {
    try {
      console.log("JDK generate - ", data);

      navigate("/success-upload-share", {
        state: {
          type: isAndroid ? "apk" : "ipa",
          fileUrl: data,
          ipaUrl: isAndroid ? null : ipaUrls,
        },
      });
    } catch (error) {
      //
    }
  };

  const generateManifestPlist = (
    ipaUrl: string,
    bundleId: string,
    appName: string,
    version: string
  ) => {
    return `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
  <dict>
    <key>items</key>
    <array>
      <dict>
        <key>assets</key>
        <array>
          <dict>
            <key>kind</key>
            <string>software-package</string>
            <key>url</key>
            <string>${ipaUrl}</string>
          </dict>
        </array>
        <key>metadata</key>
        <dict>
          <key>bundle-identifier</key>
          <string>${bundleId}</string>
          <key>bundle-version</key>
          <string>${version}</string>
          <key>kind</key>
          <string>software</string>
          <key>title</key>
          <string>${appName}</string>
        </dict>
      </dict>
    </array>
  </dict>
</plist>`;
  };

  const uploadGeneratedManifest = async () => {
    if (
      bundleId?.length === 0 &&
      appName?.length === 0 &&
      version?.length === 0
    ) {
      alert("Fill all the details");
      return;
    }
    const plist = generateManifestPlist(ipaUrl, bundleId, appName, version);

    const blob = new Blob([plist], { type: "application/xml" });
    const file = new File([blob], "manifest.plist");

    const apiData = {} as IRequestBody;
    apiData.domain = base_url;
    apiData.endPoint = api_endpoints.fileupload_S3bucket;
    apiData.showLoader = false;
    const formData = new FormData();
    formData.append("file", file);
    const input = file.name;
    const parts = input.split(".");
    const last = parts.pop();
    const modified = parts.join("_") + "." + last;

    let data = {
      type: "GENERIC",
      fileNameWithExtension: modified,
    };

    formData.append("file", file);
    formData.append("data", JSON.stringify(data));
    apiData.payLoad = formData;

    const resp = await PostFileUpload(
      apiData,
      plistUploadSuccessCallback,
      plistUploadErrorCallback,
      plistUploadProgressCallBack
    );
    plistUploadSuccessCallback(resp);
  };

  const plistUploadSuccessCallback = (response: any) => {
    setPlistUrl(response.data.imageUrl);
    // updateInDB();
  };

  useEffect(() => {
    if (plistUrl !== "") {
      updateInDB();
    }
  }, [plistUrl]);
  const plistUploadErrorCallback = (error: any) => {
    setUploadProgress(0);
  };
  const plistUploadProgressCallBack = (progressEvent: any) => {
    const percent = Math.round(
      (progressEvent.loaded * 100) / (progressEvent.total || 1)
    );
    setUploadProgress(percent);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (file) processFile(file);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) =>
    e.preventDefault();

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  const updateInDB = async () => {
    const createPayload = {
      userName: userName?.name || "Anonymous",
      fileUrl: isAndroid
        ? uploadedUrl.imageUrl
        : `itms-services://?action=download-manifest&url=${plistUrl}`,
      comments: comments,
      bundleId: "",
      version: version,
      environment: selectedEnvironment,
      osType: isAndroid ? "ANDROID" : "IOS",
      eligibleForDelete: false,
      isDeleted: false,
    };
    const apiData = {} as IRequestBody;
    apiData.domain = base_url;
    apiData.endPoint = api_endpoints.builds;
    apiData.showLoader = false;
    apiData.payLoad = createPayload;

    const resp = await CreateFileListEntry(
      apiData,
      createFileListSuccessCallback,
      createFileListErrorCallback
    );
  };

  const createFileListSuccessCallback = (response: any) => {
    if (isAndroid) {
      generateUniquePage(uploadedUrl.imageUrl, null, isAndroid);
    } else {
      generateUniquePage(
        `itms-services://?action=download-manifest&url=${plistUrl}`,
        ipaUrl,
        false
      );
    }
  };
  const createFileListErrorCallback = (error: any) => {
    console.log("Error creating file list entry:", error);
  };
  const handleChange = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedEnvironment(value);
  };
  const renderDropdown = () => {
    return (
      <Select
        name="environment"
        sx={{ minWidth: "300px", width: "100%" }}
        value={selectedEnvironment as string}
        MenuProps={{ classes: { paper: classes.Select } }}
        onChange={handleChange}
        IconComponent={() =>
          !props.isDisabled ? (
            <ExpandMoreIcon
              sx={{
                position: "absolute",
                right: "3px",
              }}
            />
          ) : null
        }
        renderValue={(value) => value}
        readOnly={!!props.isDisabled}
      >
        {environmentList?.map((value: any, index: number) => {
          return (
            <MenuItem key={index} value={`${value.environmentName}`}>
              <Typography style={{ lineHeight: "unset" }} fontSize={14}>
                {value.environmentName}
              </Typography>
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  return (
    <>
      <TableContainer>
        <div className="min-h-screen flex flex-col items-center bg-gray-50 relative w-full">
          <div className="container">
            <div className="buttoncontainer">
              <ButtonWithIcon
                type={CREATE_TYPE}
                label="Build History"
                onClick={() => navigate("/build-history")}
              />
            </div>

            <header className="header">
              <h1>🚀 Quickly Upload & Share</h1>
              <p>
                📱 Upload your .apk or .ipa file. 🔗 Get a link. 📷 Share with
                QR.
              </p>
              <button onClick={() => resetState(true)}>
                {`Upload Your File`}
              </button>
            </header>

            {showUploader && (
              <main className="main">
                <div className="uploader-container">
                  <div className="uploader-header">
                    <input
                      type="file"
                      accept=".apk,.ipa"
                      ref={fileInputRef}
                      onChange={handleMainFileChange}
                      className="hidden"
                    />
                  </div>
                  <div
                    ref={dropRef}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onClick={triggerFileInput}
                    className="drop-zone"
                  >
                    {selectedFileName.length > 0 ? (
                      <p className="mt-2 text-sm text-gray-500">
                        Selected: {selectedFileName}
                        <br />
                        {uploadProgress < 100 ? "Please wait..." : ""}
                      </p>
                    ) : (
                      "Drag & Drop .apk or .ipa here or click to choose a file"
                    )}
                    {uploadProgress > 0 && (
                      <div className="progress-bar">
                        <div
                          className="progress"
                          style={{ width: `${uploadProgress}%` }}
                        />
                      </div>
                    )}
                  </div>

                  {selectedFileName.endsWith("apk") && (
                    <div className="paddingDiv">
                      <div>
                        <label className="label">Comments:</label>
                        <input
                          type="text"
                          value={comments}
                          onChange={(e) => setComments(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="mt-4">
                        <label className="label">Build Version:</label>
                        <input
                          type="text"
                          value={version}
                          onChange={(e) => setVersion(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="paddingDiv">
                        <label className="label">Select Environment:</label>
                        {renderDropdown()}
                      </div>
                      <button
                        onClick={() => updateInDB()}
                        disabled={uploadedUrl?.imageUrl?.length === 0}
                        className={`submit-button ${
                          uploadedUrl?.imageUrl?.length > 0
                            ? "enabled"
                            : "disabled"
                        }`}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                  {/* Input fields for bundle ID, app name, and version */}
                  {selectedFileName.endsWith("ipa") && (
                    <div className="paddingDiv">
                      <div>
                        <label className="label">Bundle ID:</label>
                        <input
                          type="text"
                          value={bundleId}
                          onChange={(e) => setBundleId(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="paddingDiv">
                        <label className="label">App Name:</label>
                        <input
                          type="text"
                          value={appName}
                          onChange={(e) => setAppName(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="paddingDiv">
                        <label className="label">Build Version:</label>
                        <input
                          type="text"
                          value={version}
                          onChange={(e) => setVersion(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="paddingDiv">
                        <label className="label">Comments:</label>
                        <input
                          type="text"
                          value={comments}
                          onChange={(e) => setComments(e.target.value)}
                          className="input-field"
                        />
                      </div>
                      <div className="paddingDiv">
                        <label className="label">Select Environment:</label>
                        {renderDropdown()}
                      </div>
                      <button
                        onClick={() => uploadGeneratedManifest()}
                        disabled={ipaUrl.length === 0}
                        className={`submit-button ${
                          ipaUrl.length > 0 ? "enabled" : "disabled"
                        }`}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>
              </main>
            )}
          </div>
        </div>
      </TableContainer>
    </>
  );
};

export default UploadAndShare;
